import railwayRoutes from './routes'

/* @ngInject */
const railwayRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(railwayRoutes.index.path, {
      url: railwayRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'railwayCtrl',
      redirectTo: railwayRoutes.home.path,
    })
    .state(railwayRoutes.home.path, {
      url: railwayRoutes.home.url,
      template: require('./templates/home.html'),
    })
    .state(railwayRoutes.new.path, {
      url: railwayRoutes.new.url,
      template: require('./templates/new.html'),
    })
    .state(railwayRoutes.edit.path, {
      url: railwayRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(railwayRoutes.details.path, {
      url: railwayRoutes.details.url,
      template: require('./templates/details.html'),
    })
}

export default railwayRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/railway/railway.routes.js